import {
  ROUTE_GROUPS,
  ROUTE_GROUPS_CUSTOM_GROUP_ADD_USERS,
  ROUTE_GROUPS_CUSTOM_GROUP_EDIT,
  ROUTE_GROUPS_CUSTOM_GROUPS,
  ROUTE_GROUPS_DEPARTMENT_EDIT,
  ROUTE_GROUPS_DEPARTMENTS,
  ROUTE_GROUPS_LEADERBOARD_ADD_USERS,
  ROUTE_GROUPS_LEADERBOARD_EDIT,
  ROUTE_GROUPS_LEADERBOARDS,
  ROUTE_GROUPS_POSITION_EDIT,
  ROUTE_GROUPS_POSITIONS,
} from '@/router/routes/routeNames'

const Groups = () => import('@/components/groups/GroupsView.vue')
const Departments = () =>
  import('@/components/groups/group_department/GroupDepartmentView.vue')
const DepartmentEdit = () =>
  import('@/components/groups/group_department/GroupDepartmentEditView.vue')
const Positions = () =>
  import('@/components/groups/group_position/GroupPositionView.vue')
const PositionEdit = () =>
  import('@/components/groups/group_position/GroupPositionEditView.vue')
const CustomGroups = () =>
  import('@/components/groups/group_custom/GroupCustomListView.vue')
const CustomGroupEdit = () =>
  import('@/components/groups/group_custom/GroupCustomEditView.vue')
const CustomGroupAddUser = () =>
  import('@/components/groups/group_custom/GroupCustomAddUserView.vue')
const LeaderboardGroups = () =>
  import('@/components/groups/group_leaderboard/GroupLeaderboardListView.vue')
const LeaderboardGroupEdit = () =>
  import('@/components/groups/group_leaderboard/GroupLeaderboardEditView.vue')
const LeaderboardGroupAddUser = () =>
  import(
    '@/components/groups/group_leaderboard/GroupLeaderboardAddUserView.vue'
  )

const groupRoutes = [
  {
    name: ROUTE_GROUPS,
    path: '/users/groups',
    component: Groups,
    redirect: '/users/groups/positions', // Goto first tab
    meta: { resource: 'Groups' },
    children: [
      {
        name: ROUTE_GROUPS_POSITIONS,
        path: '/users/groups/positions',
        components: { groups: Positions },
        props: true,
        meta: { resource: 'Groups', id: 0 },
      },
      {
        name: ROUTE_GROUPS_DEPARTMENTS,
        path: '/users/groups/departments',
        components: { groups: Departments },
        props: true,
        meta: { resource: 'Groups', id: 1 },
      },
      {
        name: ROUTE_GROUPS_CUSTOM_GROUPS,
        path: '/users/groups/custom-groups',
        components: { groups: CustomGroups },
        props: true,
        meta: { resource: 'Groups', id: 2 },
      },
      {
        name: ROUTE_GROUPS_LEADERBOARDS,
        path: '/users/groups/leaderboard-groups',
        components: { groups: LeaderboardGroups },
        props: true,
        meta: { resource: 'Groups', id: 3 },
      },
    ],
  },
  {
    name: ROUTE_GROUPS_DEPARTMENT_EDIT,
    path: '/users/groups/departments/:groupId',
    component: DepartmentEdit,
    props: true,
    meta: { resource: 'Groups', isMaster: false },
  },
  {
    name: ROUTE_GROUPS_POSITION_EDIT,
    path: '/users/groups/positions/:groupId',
    component: PositionEdit,
    props: true,
    meta: { resource: 'Groups', isMaster: false },
  },
  {
    name: ROUTE_GROUPS_CUSTOM_GROUP_EDIT,
    path: '/users/groups/custom-groups/:groupId',
    component: CustomGroupEdit,
    props: true,
    meta: { resource: 'Groups' },
  },
  {
    name: ROUTE_GROUPS_CUSTOM_GROUP_ADD_USERS,
    // :groupId is constrained to digits so a malformed URL (e.g. a literal
    // "undefined") never resolves here and fires the user-list query with an
    // invalid not_in_group_id filter — the FAME-103 full-list leak.
    path: '/users/groups/custom-groups/:groupId(\\d+)/add-users',
    component: CustomGroupAddUser,
    props: true,
    meta: { resource: 'Groups' },
  },
  {
    name: ROUTE_GROUPS_LEADERBOARD_EDIT,
    path: '/users/groups/leaderboard-groups/:groupId',
    component: LeaderboardGroupEdit,
    props: true,
    meta: { resource: 'Groups' },
  },
  {
    name: ROUTE_GROUPS_LEADERBOARD_ADD_USERS,
    path: '/users/groups/leaderboard-groups/:groupId(\\d+)/add-users',
    component: LeaderboardGroupAddUser,
    props: true,
    meta: { resource: 'Groups' },
  },
]

export default groupRoutes
